import { createTheme, ThemeProvider } from '@mui/material';

function MuiTheme({ children }) {
	const theme = createTheme({
		direction: 'rtl',
		typography: {
			fontFamily: `dana, ubuntu, tahoma`,
		},
	});

	return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export default MuiTheme;
